import { render } from "./ExamMgt.vue?vue&type=template&id=75686ba2"
import script from "./ExamMgt.vue?vue&type=script&lang=js"
export * from "./ExamMgt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__